import React from 'react';

export const WizardHeader = ({ component: Component }) => <Component />;

export const WizardContent = ({ component: Component }) => <Component />;

export const WizardFooter = ({ component: Component }) => <Component />;
